import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'swb-offices',
    templateUrl: './offices.component.html'
})
export class OfficesComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
